export default __webpack_public_path__ + "static/media/star-selected.96c76788.svg";